import { Button, Card, IconTile } from "@design";
import { useQuery } from "@tanstack/react-query";
import { Bot, ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { listAgentPinsOptions } from "@/api";
import { QuerySection } from "@/components/section";
import { Text } from "@/components/Text";

/** Agents the user starred; clicking one starts a chat with it. */
export function PinnedAgents() {
  const { t } = useTranslation("home", { keyPrefix: "agents" });
  const navigate = useNavigate();
  const pins = useQuery({ ...listAgentPinsOptions(), select: (r) => r.data });
  return (
    <section aria-label={t("title")} className="flex flex-col gap-2">
      <div className="flex min-h-8 items-center justify-between">
        <Text as="h2" variant="eyebrow" tone="tertiary">
          {t("title")}
        </Text>
        <div className="-mr-3">
          <Button
            variant="text"
            size="sm"
            trailingIcon={<ChevronRight size={12} />}
            onClick={() => navigate("/build/agents")}
          >
            {t("all")}
          </Button>
        </div>
      </div>
      <QuerySection
        query={pins}
        isEmpty={(list) => list.length === 0}
        empty={{ icon: <Bot size={18} />, hint: t("empty") }}
        loadingRows={2}
      >
        {(agents) => (
          <ul className="grid grid-cols-1 gap-2 min-[480px]:grid-cols-2 sm:grid-cols-3">
            {agents.map((agent) => (
              <li key={agent.uuid} className="flex">
                <Card
                  size="xs"
                  onClick={() => navigate(`/chat?agent=${agent.uuid}`)}
                  className="flex items-start gap-2.5"
                >
                  <IconTile size="sm">
                    <Bot size={14} />
                  </IconTile>
                  <span className="min-w-0 flex-1">
                    <Text as="span" variant="body-sm" weight="semibold" className="block truncate">
                      {agent.name}
                    </Text>
                    {agent.description && (
                      <Text as="span" variant="caption" tone="tertiary" className="mt-1 block truncate">
                        {agent.description}
                      </Text>
                    )}
                  </span>
                </Card>
              </li>
            ))}
          </ul>
        )}
      </QuerySection>
    </section>
  );
}
